// This file is auto-generated by @hey-api/openapi-ts

import { z } from 'zod';

export const zGenerateTokenRequest = z.object({
    username: z.string(),
    password: z.string(),
    keepSignedIn: z.boolean().optional().default(true)
});

export const zLoginTokens = z.object({
    access_token: z.string(),
    expires_in: z.string(),
    id_token: z.string(),
    refresh_token: z.string().nullable(),
    token_type: z.string().nullish()
});

export const zSsoRedirect = z.object({
    redirect: z.literal(true),
    connection: z.string(),
    path: z.string()
});

export const zPasswordResetRequired = z.object({
    userId: z.string(),
    username: z.string(),
    needsPasswordReset: z.literal(true)
});

export const zMfaChallenge = z.object({
    enabled: z.boolean(),
    enforce: z.boolean(),
    type: z.string(),
    userId: z.string(),
    bypass: z.boolean()
});

export const zRefreshTokenRequest = z.object({
    refreshToken: z.string()
});

export const zRefreshedTokens = z.object({
    access_token: z.string(),
    expires_in: z.number().int().optional(),
    id_token: z.string().optional(),
    refresh_token: z.string().optional(),
    scope: z.string().optional(),
    token_type: z.string().optional()
});

export const zLogoutRequest = z.object({
    refreshToken: z.string()
});

/**
 * Structured error from a platform backend service (the shared
 * `libs/backend/errors` package). The same shape is emitted by every Go
 * service, so endpoint specs reference it rather than redefining it.
 *
 */
export const zAppError = z.object({
    errorId: z.string(),
    timestamp: z.string().datetime(),
    statusCode: z.number().int().optional(),
    message: z.string().optional(),
    operation: z.string().optional(),
    objectType: z.string().optional(),
    objectId: z.string().optional(),
    attributes: z.record(z.unknown()).optional()
});

/**
 * Error envelope returned by platform backend services. Clients should
 * read `appError`; `errorMessage` and `error` are legacy compatibility
 * fields kept for older consumers.
 *
 */
export const zAppErrorResponse = z.object({
    appError: zAppError,
    errorMessage: z.string().optional(),
    error: z.string().optional()
});

export const zGenerateTokenBody = zGenerateTokenRequest;

/**
 * Tokens, or the next step the sign-in needs
 */
export const zGenerateTokenResponse = z.union([
    zLoginTokens,
    zSsoRedirect,
    zPasswordResetRequired,
    zMfaChallenge
]);

export const zRefreshTokenBody = zRefreshTokenRequest;

/**
 * New tokens
 */
export const zRefreshTokenResponse = zRefreshedTokens;

export const zLogoutBody = zLogoutRequest;

/**
 * Refresh token revoked
 */
export const zLogoutResponse = z.void();
